export default class WalletLaunchLinkSwap {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    async _default(payload) {
        if (!this.gb.settings || !this.gb.settings.walletLaunchLink) {
            logger.warn("walletLaunchLinkSwap received but settings.walletLaunchLink is not enabled — ignoring");
            return;
        }

        const newConfig = payload && payload.data ? payload.data : payload;

        if (!newConfig || typeof newConfig !== "object") {
            logger.error("walletLaunchLinkSwap payload missing or invalid", payload);
            return;
        }

        try {
            await this.gb.swapGame(newConfig);
        } catch (e) {
            logger.error("walletLaunchLinkSwap failed", e);
        }
    }

    exposeEvent() {
        return {
            walletLaunchLinkSwap: this._default
        };
    }
}
